import React from 'react';
import NextLink from 'next/link';
import { mergeClassLists } from 'tailwind-classlist';
import { classes } from './utils';

export default function Link({ className = '', ...props }) {
  return (
    <NextLink className={mergeClassLists(classes.link, className)} {...props} />
  );
}
